import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_RECEIVE_INVENTORY,
   UPDATE_RECEIVE_INVENTORY,
   GET_RECEIVE_INVENTORIES,
   GET_RECEIVE_INVENTORIES_FOR_RO,
   GET_RECEIVE_INVENTORIES_FOR_ITV,
   GET_RECEIVE_INVENTORIES_FOR_RFV,
   GET_RECEIVE_INVENTORIES_FOR_S,
   GET_RECEIVE_INVENTORIES_FOR_R,
   GET_RECEIVE_INVENTORY,
   DELETE_RECEIVE_INVENTORY,
   EMPTY_ONE_RECEIVE_INVENTORY,
   GET_LAST_RECEIVE_DAYBOOK,
   GET_RECEIVE_INVENTORY_PREV_AND_NEXT,
   GET_PENDING_RECEIVE_INVENTORY,
   GET_SINGLE_RECEIVE_INVENTORIES,
   DELETE_RECEIVE_DOC,
   UPDATE_RECEIVE_DOC,
   DELETE_MULTI_RECEIVE,
} from '../types';

export const deleteMultiReceive = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/receive-inventory/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_RECEIVE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Receive Invoice deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const addReceiveInventory = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/receive-inventory/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_RECEIVE_INVENTORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Receive Inventory added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/receive-inventory/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

export const getReceiveInventories = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const getReceiveInventoriesForRO = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES_FOR_RO,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const getReceiveInventoriesForITV = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES_FOR_ITV,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const getReceiveInventoriesForRFV = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES_FOR_RFV,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const getReceiveInventoriesForS = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES_FOR_S,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
export const getReceiveInventoriesForR = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORIES_FOR_R,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSingleReceiveInventories = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SINGLE_RECEIVE_INVENTORIES,
            payload: {
               data: res.data.data || [],
               // pagination: res.data.pagination || {},
               // totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getPendingReceiveInventories = () => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/pending-receive`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_PENDING_RECEIVE_INVENTORY,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getReceiveInventory = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/receive-inventory/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_RECEIVE_INVENTORY,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
         return res.data.data;
      }
   } catch (err) {
      console.error('getIssueInventory err', err);
   }
};

export const deleteReceiveInventory = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/receive-inventory/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: DELETE_RECEIVE_INVENTORY,
            payload: { id },
         });
         setTimeout(() => {
            toast.success('Issue Inventory deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateReceiveInventory = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/receive-inventory/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_RECEIVE_INVENTORY, payload: res.data.data });
         setTimeout(() => {
            toast.success('Issue Inventory updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const getLastReceiveDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      // const res = await axios.get(`/receive/last`, { params });
      const res = await axios.get(`/receive-inventory/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_RECEIVE_DAYBOOK, payload: res.data.data });
      }
   } catch (err) {
      console.error('getLastIssueDaybook err', err);
   }
};

export const emptyReceiveInventory = () => async (dispatch) => {
   dispatch({ type: EMPTY_ONE_RECEIVE_INVENTORY, payload: null });
};

export const getPrevAndNext = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/purchase-invoice/prev-next`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_RECEIVE_INVENTORY_PREV_AND_NEXT, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const addReceiveReason = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/receive-inventory/update/addReturn`, formData);
      if (res.data.code === 1) {
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
      return err.response.data;
   }
};

export const uploadReceiveDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/receive-inventory/addImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_RECEIVE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deleteReceiveDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/receive-inventory/deleteImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: DELETE_RECEIVE_DOC, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
